import styled from "styled-components";

export const ResultList = styled.ul`
  width: 100%;
  height: 100%;
  margin: 0;
  padding-top: 9px;
`;
